import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import extandDayjs from "../../helpers/dayjs";
import { showNotification } from "./notificationSlice";
const suspensionOvertimeApi = factory.get("suspension_overtime");

const initialState = {
  suspension_overtime: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 100,
      page: 0,
      user_id: "",
      department_id: "",
      start_date: extandDayjs().format("YYYY-MM-DD"),
      end_date: extandDayjs().format("YYYY-MM-DD"),
      status_id: null,
    },
  },
};

export const suspensionOvertimeSlice = createSlice({
  name: "suspensionOvertime",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.suspension_overtime.dialog = !state.leave.dialog;
      state.suspension_overtime.form.id = action.payload ? action.payload : "";
    },
    setDataTable: (state, { payload }) => {
      state.suspension_overtime.data = payload.data.data;
      state.suspension_overtime.total = payload.data.total;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.suspension_overtime.filters = {
        ...state.suspension_overtime.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.suspension_overtime.filters =
        initialState.suspension_overtime.filters;
    },
  },
});

export const { setLoading, setDialog, setDataTable, setFilters, resetFilters } =
  suspensionOvertimeSlice.actions;

export default suspensionOvertimeSlice.reducer;

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    const filters = getState().suspensionOvertime.suspension_overtime.filters;

    const filters_params = {
      ...filters,
      start_date: filters.date_type === "month" ? null : filters.start_date,
      end_date: filters.date_type === "month" ? null : filters.end_date,
      date: filters.date_type === "month" ? filters.date : null,
      user_id: filters.user_id?.length > 0 ? filters.user_id.map((item => item.id)) : null,
    };

    dispatch(setLoading("suspension_overtime"));
    const res = await suspensionOvertimeApi.getAll(filters_params);
    dispatch(setDataTable(res));
    dispatch(setLoading("suspension_overtime"));
  } catch (err) {
    dispatch(setLoading("suspension_overtime"));
    throw new Error(err);
  }
};
const changeStatus = (id, status) => async (dispatch) => {
  try {
    await suspensionOvertimeApi.changeStatus(id, status);
    dispatch(getAll());
    dispatch(
      showNotification({
        message: "تم تغيير الحالة بنجاح",
        type: "success",
      })
    );
  } catch (err) {
    //set notification error
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("suspension_overtime"));
    const res = await suspensionOvertimeApi.update(data);
    dispatch(setLoading("suspension_overtime"));

    dispatch(getAll());
    dispatch(
      showNotification({
        message: "تم تحديث بنجاح",
        type: "success",
      })
    );
    return res;
  } catch (err) {
    dispatch(setLoading("suspension_overtime"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const suspensionOvertimeActions = {
  getAll,
  changeStatus,
  update,
};
